<!-- eslint-disable max-len -->
<template>
  <div
    id="modal-email-validation"
    class="modal fade"
    tabindex="-1"
    aria-labelledby="modalEmailValidation"
    aria-hidden="true"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <p v-if="isMobile" class="w-100 text-start fs-5 fw-600 m-0">
            Validação por E-mail
          </p>

          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
            @click="exitModal"
          />
        </div>
        <div class="modal-body">
          <h4 v-if="!isMobile" class="mb-4">Validação por E-mail</h4>

          <div class="mb-4">
            <p class="w-100 text-start fs-6 mb-2">Selecione um e-mail *</p>

            <Selectable
              :key="emailSelectableKey"
              v-model="selectedEmail"
              icon="envelope"
              placeholder="Selecione uma opção"
              :options="emailOptions"
            />
          </div>

          <div v-if="emailWasSended" class="mb-3">
            <Input
              v-model="code"
              label="Digite abaixo o código enviado para seu e-mail *"
              placeholder="Digite o código"
              icon="lock-keyhole"
              :error-log="error"
            />
          </div>

          <div v-if="emailWasSended">
            <button
              v-if="!canResendCode"
              type="button"
              class="btn btn-secondary btn-sm white-text-button"
              disabled
            >
              Reenviar código em {{ secondsToResendCode }} segundos
            </button>

            <button
              v-if="canResendCode"
              type="button"
              class="btn btn-outline-primary btn-sm"
              @click="sendCodeToEmail"
            >
              Reenviar código
            </button>
          </div>
        </div>

        <div class="modal-footer">
          <div v-if="!isMobile" class="w-100 d-flex justify-content-between">
            <button
              type="button"
              data-bs-dismiss="modal"
              class="button-without-border"
              @click="exitModal"
            >
              Escolher outro tipo de validação
            </button>

            <button
              v-if="!emailWasSended"
              type="button"
              :class="[
                'btn btn-sm',
                !emailIsSelected
                  ? 'btn-secondary white-text-button'
                  : 'btn-primary',
              ]"
              :disabled="!emailIsSelected"
              @click="sendCodeToEmail"
            >
              <span class="me-2">Enviar código</span>
              <Icon name="arrow-right" />
            </button>

            <button
              v-if="emailWasSended"
              type="button"
              class="btn btn-primary btn-sm"
              :class="[
                'btn btn-sm',
                !emailIsSelected || code === ''
                  ? 'btn-secondary white-text-button'
                  : 'btn-primary',
              ]"
              :disabled="!emailIsSelected || code === ''"
              @click="validateEmail"
            >
              <span class="me-2">Iniciar validação</span>
              <Icon name="arrow-right" />
            </button>
          </div>

          <div v-else>
            <button
              v-if="!emailWasSended"
              type="button"
              :class="[
                'btn mb-4',
                !emailIsSelected
                  ? 'btn-secondary white-text-button'
                  : 'btn-primary',
              ]"
              :disabled="!emailIsSelected"
              @click="sendCodeToEmail"
            >
              <span class="me-2">Enviar código</span>
            </button>

            <button
              v-if="emailWasSended"
              type="button"
              :class="[
                'btn mb-4',
                !emailIsSelected || code === ''
                  ? 'btn-secondary white-text-button'
                  : 'btn-primary',
              ]"
              :disabled="!emailIsSelected || code === ''"
              @click="validateEmail"
            >
              <span class="me-2">Iniciar validação</span>
            </button>

            <button
              type="button"
              data-bs-dismiss="modal"
              class="button-without-border"
              @click="exitModal"
            >
              Escolher outro tipo de validação
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
  import { defineComponent } from 'vue'
  import Selectable from '@/components/Atoms/Selectable.vue'
  import Input from '@/components/Atoms/Input.vue'
  import Icon from '@/components/Atoms/Icon.vue'
  import { Modal } from 'bootstrap'
  import browserDeviceCheck from '@/utils/browserDeviceCheck'
  import emailValidationController from '@/infra/DomainValidation/email.controller'
  import { mapActions, mapState } from 'pinia'
  import { useToastGlobal } from '@/store/Pinia/useToastGlobal.store'
  import { useDynamicForms } from '@/store/Pinia/useDynamicForms.store'
  import { useSolicitation } from '@/store/Pinia/useSolicitation.store'
  import { AxiosError } from 'axios'

  interface SelectableOption {
    id: number
    value: string
    label: string
    nome: string
  }

  export default defineComponent({
    components: {
      Selectable,
      Input,
      Icon,
    },
    props: {
      selectedDomain: {
        type: String,
        required: true,
      },
      error: {
        type: String,
      },
    },
    data: () => ({
      isMobile: browserDeviceCheck(),
      emailOptions: [] as SelectableOption[],
      selectedEmail: '',
      emailSelectableKey: 1,
      emailWasSended: false,
      secondsToResendCode: 0,
      secondsCountDown: null as ReturnType<typeof setInterval> | null,
      code: '',
      modal: null as HTMLDialogElement | null,
    }),
    computed: {
      ...mapState(useDynamicForms, ['getPassword']),
      ...mapState(useSolicitation, ['getSolicitation']),
      emailIsSelected() {
        if (this.selectedEmail !== '') {
          return true
        }
        return false
      },
      canResendCode() {
        if (this.secondsToResendCode === 0) {
          return true
        }
        return false
      },
    },
    methods: {
      ...mapActions(useToastGlobal, ['toggleToastGlobal']),
      startSecondsCountDown() {
        clearInterval(this.secondsCountDown)
        this.secondsCountDown = setInterval(() => {
          if (this.secondsToResendCode > 0) {
            this.secondsToResendCode -= 1
            return
          }
          clearInterval(this.secondsCountDown)
        }, 1000)
      },
      clearData() {
        this.selectedEmail = ''
        this.secondsToResendCode = 0
        clearInterval(this.secondsCountDown)
        this.emailWasSended = false
        this.code = ''
      },
      exitModal() {
        this.clearData()
        this.emailSelectableKey += 1
      },
      async fetchEmails() {
        const response = await emailValidationController.getEmails({
          codigo: this.getSolicitation.cdSolicitacao,
          senha: this.getPassword,
        })
        const emailList = response.emails.find(
          (emailListOptoin) =>
            // eslint-disable-next-line implicit-arrow-linebreak
            this.selectedDomain.includes(emailListOptoin.domain),
          // eslint-disable-next-line function-paren-newline
        ) as {
          domain: string
          emails: string[]
        }

        this.emailOptions = emailList.emails.map((email, index) => ({
          id: index,
          label: email,
          value: email,
          nome: email,
        }))
      },
      async sendCodeToEmail() {
        try {
          this.secondsToResendCode = 30
          this.startSecondsCountDown()
          await emailValidationController.sendCodeToEmail({
            codigo: this.getSolicitation.cdSolicitacao,
            senha: this.getPassword,
            domain: this.selectedDomain,
            email: this.selectedEmail,
          })
        } catch (error) {
          const err = error as AxiosError<{ message: string }>
          let message = 'Erro ao enviar código para o email'
          if (
            err.response?.data.message ===
            'matheuscfrancisco.dev.br already verified'
          ) {
            message = `${err.response?.data.message.replace(
              ' already verified',
              '',
            )} já foi validado.`
          }

          this.toggleToastGlobal({
            isShow: true,
            type: 'danger',
            message,
          })
        } finally {
          this.emailWasSended = true
        }
      },
      modalOpen() {
        this.modal.show()
      },
      modalClose() {
        this.modal.hide()
      },
      async validateEmail() {
        this.$emit('validate-email', this.code)
      },
    },
    mounted() {
      const modal = document.getElementById(
        'modal-email-validation',
      ) as HTMLElement
      this.modal = new Modal(modal, {})
    },
  })
</script>

<style scoped>
  .modal-content {
    background-color: #fcfcfc;
  }

  .modal-footer > * {
    margin: 0 !important;
  }

  .white-text-button {
    color: white;
  }

  .button-without-border {
    border: none !important;
    background: none !important;
    font-size: 14px;
  }

  @media screen and (max-width: 576px) {
    .modal-dialog {
      height: auto;
      margin: 0.5rem;
    }
    .modal-content {
      border-radius: 0.5rem;
    }
  }
</style>
